export default {
  nav: {
    apartments: "Apartments",
    manifesto: "Manifesto",
    map: "Map",
    contact: "Contact",
    book: "Book now",
    menu: "Menu",
  },
  lang: { es: "Español", en: "English", fr: "Français", de: "Deutsch" },
  hero: {
    kicker: "Temporary rental in Cádiz city",
    line1: "Luz de Cádiz",
    line2: "apartments",
    sub: "Four flats perfect for groups of up to 8 people, on Playa Victoria or in the old town. Book direct, no fees.",
    cta1: "View apartments",
    badge: "Remote work & stays over 1 month: special terms",
    scroll: "Scroll",
  },
  manifesto: {
    kicker: "Manifesto",
    chapters: [
      { n: "01", title: "The light", text: "Cádiz has a light that exists nowhere else: it comes in sideways, white, and makes everything sharp. Our homes are designed to let it in." },
      { n: "02", title: "The salt", text: "The Atlantic can be breathed in every street. La Caleta, La Cortadura, the seafront promenade: the sea is never more than ten minutes from your door." },
      { n: "03", title: "The lime", text: "Whitewashed patios, hand-painted tiles, oyster stone. Four light-filled homes, each with its own neighbourhood and character." },
    ],
  },
  gallery: {
    kicker: "The collection",
    title: "Four homes, one ocean",
    sub: "From the Old Town to La Cortadura: choose your Cádiz.",
    guests: "guests",
    bedrooms: "bedr.",
    from: "from",
    night: "night",
    view: "View apartment",
  },
  marquee: { items: ["Sea salt", "Sunsets", "Turquoise Atlantic", "Pescaíto frito", "Oyster stone"] },
  map: {
    kicker: "The map",
    title: "Where to stay in Cádiz",
    sub: "Four hand-picked locations, from the old town to the beach.",
    view: "View apartment",
  },
  contact: {
    kicker: "Contact",
    title: "Let's talk",
    sub: "Tell us what you're looking for and we'll reply within 24 hours. You can also message us directly on WhatsApp.",
    name: "Name",
    email: "Email",
    phone: "Phone (optional)",
    message: "Message",
    send: "Send message",
    whatsapp: "Send via WhatsApp",
    success: "Message sent. We reply within 24 h.",
    error: "Could not send. Try again or message us on WhatsApp.",
    response: "Reply within 24 h",
  },
  footer: {
    tagline: "Four apartments in Cádiz city: Playa Victoria and the old town.",
    rights: "All rights reserved.",
    seo: "Temporary rental in Cádiz · Temporary apartments in Cádiz city · Flats to rent in Playa Victoria and the Old Town · Remote work & teleworking by the sea · Stays over a month with special deals",
  },
  detail: {
    from: "from",
    perNight: "/ night",
    guests: "guests",
    bedrooms: "bedrooms",
    baths: "bathrooms",
    area: "m²",
    house: "The home",
    amenities: "Amenities",
    district: "The neighbourhood",
    where: "Where it is",
    openMaps: "Open in Google Maps",
    back: "Back to the collection",
    notFound: "Apartment not found",
    longstayBadge: "Remote workers · Stays over 1 month · Special deals — ask about prices & terms",
    mapBlocked: "You've rejected third-party cookies, so the Google map doesn't load here. You can open the location directly in Google Maps:",
  },
  booking: {
    title: "Book your stay",
    checkin: "Check-in",
    checkout: "Check-out",
    nights: "nights",
    night: "night",
    total: "Total",
    taxes: "Taxes calculated at checkout",
    cta: "Book & pay",
    whatsapp: "Ask on WhatsApp",
    name: "Full name",
    email: "Email",
    phone: "Phone",
    errDates: "Choose your check-in and check-out dates",
    errFields: "Fill in your name, email and phone",
    errConflict: "Those dates were just taken. Please choose others.",
    errGeneric: "Payment could not be started. Please try again.",
    secure: "Secure payment with Stripe · Instant confirmation",
    legendFree: "Available",
    legendBusy: "Booked",
    loading: "Redirecting to payment…",
    dogs: "Dogs",
    cribs: "Baby (cot)",
    cleaning: "Final cleaning",
    linen: "Bed linen & towels",
    petsFee: "Pets",
    discountLine: "Long-stay discount (−{{pct}}%)",
    consult: "For stays longer than a month we have special deals: ask us on WhatsApp",
    rateTitle: "Choose your rate",
    rateFlex: "Flexible rate",
    rateStd: "Standard rate",
    rateFlexPolicy: "Free first 24 h · Up to 15 days before check-in: 90% back (minus the deposit) · 14 to 7 days before: 50% · From 6 days before: no refund",
    rateStdPolicy: "15% off the accommodation · Non-refundable after the first 24 h",
    depositNote: "Booking deposit: {{amount}} non-refundable under any rate once 24 h have passed since booking.",
    datesTitle: "Change dates",
    nonrefLine: "Non-refundable rate (−15% accommodation)",
    linenOptional: "optional",
    extrasNote: "Free cots & high chairs on request · Free dog beds & bowls on request",
    helpEmailSubject: "Refund request · {{apartment}}",
    errSummer: "In July and August the minimum stay is 4 nights (you have {{nights}})",
    errWeekend: "Friday and Saturday nights must be booked together",
    altTitle: "This flat isn't free on those dates. These are available:",
    altDatesTitle: "Same flat, alternative dates (same nights):",
    altNone: "No other flat is free on those dates: message us on WhatsApp and we'll look into it.",
    openNote: "For now, online bookings are for July and August. For other dates, message us on WhatsApp.",
    closed: "The requested dates are fully booked. Please contact {{email}} for more information.",
    errOpenMonths: "For now only July and August dates can be booked online",
    payTitle: "Payment method",
    pay_card: "Card · Apple/Google Pay",
    pay_paypal: "PayPal",
    pay_bizum: "Bizum",
    feeService: "Payment processing fee (1%)",
    codePlaceholder: "Got a discount code?",
    codeApply: "Apply",
    codeOk: "Code applied: −{{pct}}%",
    codeInvalid: "Invalid code",
    codeApplied: "Code {{code}} (−{{pct}}%) applied",
    codeRemove: "Remove",
    codeLine: "Code {{code}} (−{{pct}}%)",
  },
  success: {
    checking: "Confirming your booking…",
    title: "Booking confirmed",
    sub: "We've emailed you the details. See you in Cádiz.",
    entry: "Check-in",
    exit: "Check-out",
    nights: "Nights",
    total: "Total",
    whatsapp: "Let us know on WhatsApp",
    home: "Back to home",
    pending: "Verifying payment",
    pendingSub: "We're confirming your payment with the bank. It will update in a few seconds.",
    sepaPending: "We've registered your SEPA direct debit. The bank will process the charge within 1-3 business days and your booking will be confirmed automatically by email.",
    rate: "Rate",
    rateFlex: "Flexible",
    rateNonref: "Non-refundable (−15%)",
    helpTitle: "Need to cancel or request a refund?",
    helpWa: "Message on WhatsApp",
    helpEmail: "Send email",
  },
  search: {
    results: "Availability",
    cta: "Search",
    stay: "{{nights}} nights · {{guests}} guests",
    totalStay: "Stay total",
    book: "View & book",
    modify: "Edit search",
    available: "Available",
    noneTitle: "No full availability",
    noneSub: "No apartment is free for those dates and that number of guests. Try other dates or message us on WhatsApp.",
    noDates: "Booked on those dates",
    altDates: "Alternative dates for this flat",
    noCapacity: "Maximum capacity: {{max}} guests",
    unavailableTitle: "Unavailable for your search",
    resultsFor: "Available from {{from}} to {{to}}",
  },
  cancel: {
    title: "Booking cancelled",
    sub: "No charge has been made. You can try again whenever you like.",
    back: "Back to the collection",
  },
  amenities: {
    wifi: "Fibre Wi-Fi",
    ac: "Air conditioning",
    kitchen: "Equipped kitchen",
    washer: "Washing machine",
    tv: "TV",
    nespresso: "Nespresso",
    linen: "Bed linen & towels optional",
    babykit: "Free cots & high chairs on request",
    petkit: "Free dog beds & bowls on request",
    beachview: "Uninterrupted beach views",
    seaview: "Partial sea views",
    balcony: "West-facing balcony",
    dryer: "Hairdryer",
    iron: "Iron",
    patio: "Private Andalusian patio",
    bbq: "Portable barbecue",
    terrace: "Private terrace",
    parking: "Nearby parking",
    bikes: "Bicycles included",
    guide: "Curated local guide",
    light: "Sunlit mezzanine",
    lift: "Lift",
  },
  whatsapp: {
    floatLabel: "Message us on WhatsApp",
    generic: "Hi, I'm interested in one of your apartments in Cádiz.",
    booking: "Hi, I'd like to check availability for {{apartment}} ({{checkin}} → {{checkout}}).",
    successMsg: "Hi, I just booked {{apartment}} from {{checkin}} to {{checkout}}. Thanks!",
    refund: "Hi, I'd like to request the cancellation/refund of my booking at {{apartment}} ({{checkin}} → {{checkout}}).",
  },
  remote: {
    kicker: "Remote work in Cádiz",
    title: "Work remotely facing the Atlantic",
    text: "Fibre Wi-Fi, spacious bright flats and discounts of up to 55% on long stays. Staying over a month? Message us — we have special deals for remote workers.",
    cta: "See terms & contact",
    waMsg: "Hi, I work remotely and I'm interested in a long stay (over a month) in one of your flats in Cádiz. What special deals do you have?",
  },
  longstay: {
    kicker: "Remote work & long stays",
    title: "Work remotely facing the Atlantic",
    sub: "Four spacious, bright flats — by the beach or in the Old Town — with fibre Wi-Fi and everything you need to live in Cádiz for a season.",
    f1t: "Fibre Wi-Fi",
    f1d: "Fast, stable connection for video calls and uninterrupted daily work.",
    f2t: "Light-filled spaces",
    f2d: "Large, exterior flats with plenty of natural light and comfortable spots to work.",
    f3t: "Automatic discounts",
    f3d: "−30% from 7 nights, −40% from 8 and −55% from 16, applied directly when booking.",
    f4t: "Over a month",
    f4d: "Message us on WhatsApp or with the form and we'll make you a special deal for remote workers.",
    note: "Temporary rental in Cádiz · Remote work & teleworking by the sea · Long-stay special deals",
  },
  instr: {
    kicker: "Almost there",
    title: "Complete your payment",
    loading: "Loading…",
    error: "We can't find this booking. Message us on WhatsApp.",
    amount: "Amount to pay",
    ref: "Reference",
    aptLabel: "Apartment",
    datesLabel: "Dates",
    bizumText: "Send the amount by Bizum to {{phone}} with the booking reference.",
    transferText: "We've just emailed you the bank details for the transfer. Please include the booking reference.",
    paypalText: "Send the amount via PayPal to {{email}} with the booking reference.",
    warning: "Important: your booking stays PENDING until we receive your payment. Dates are not firmly blocked until then.",
    received: "As soon as we receive it, we'll email your confirmation.",
    whatsapp: "Let us know on WhatsApp",
    waMsg: "Hi, I've just made the payment for my booking {{ref}} ({{apartment}}).",
  },
  paypal: {
    title: "Pay with PayPal",
    notCompleted: "The payment was not completed",
    error: "The PayPal payment could not be processed",
    notConfigured: "PayPal is being activated. In the meantime, message us on WhatsApp and we'll give you another way to pay.",
  },
  cookies: {
    text: "We use our own technical cookies and third-party ones (Stripe/PayPal payments and Google Maps) so the site works properly. We don't track or sell your data.",
    accept: "Accept",
    reject: "Reject",
    more: "More information",
  },
  rules: {
    title: "House rules",
    r1: "Check-in: 3 pm · Check-out: 12 pm",
    r2: "No noise after 10 pm",
    r3: "No smoking in the flat, the hallway or the patios",
    r4: "Security deposit of €300 per week: charged with the same payment method at check-in, after reviewing the state of the flat together, and returned at check-out after a new inspection. If anything doesn't match the condition report handed to you, let us know within 12 hours of arrival.",
    r5: "Whenever possible, we'll take each guest's needs into account.",
  },
  legal: {
    notice: "Legal notice",
    privacy: "Privacy",
    cookies: "Cookies",
    cancel: "Cancellation policy",
    terms: "Stay conditions",
  },
  checkin: {
    kicker: "Online check-in",
    notFound: "We can't find this booking",
    backHome: "Back to the website",
    doneTitle: "Check-in completed",
    doneText: "Guests registered, property condition signed and deposit held. We look forward to welcoming you on {{date}} from 3:00 pm.",
    summary: "{{checkin}} → {{checkout}} · {{nights}} nights · {{guests}} guests",
    step1: "1 · Details of all occupants",
    step1Note: "Required by the Spanish traveller registry regulations. Please fill in the details of each person staying.",
    occupant: "Occupant {{n}}",
    remove: "Remove",
    firstName: "First name *",
    lastName: "Surname *",
    docId: "ID / Passport *",
    birthdate: "Date of birth",
    nationality: "Nationality",
    address: "Home address",
    addOccupant: "Add occupant",
    step2: "2 · Property condition",
    stateIntro: "The apartment is handed over in perfect condition with all household items included. I undertake to check it upon arrival.",
    stateDeadline: "I have 24 hours from check-in",
    stateRest: " to report any issue. After that period, any damage or missing items found may be deducted from the deposit. By signing, I accept these conditions.",
    signReady: "Signature ready",
    signHint: "Draw your signature with your finger or mouse",
    signClear: "Clear",
    step3: "3 · Security deposit ({{amount}} €)",
    depositText1: "{{perWeek}} € per week. ",
    depositBold: "It is only held on your card, not charged.",
    depositText2: " It is automatically released after the check-out inspection if everything is in order.",
    depositOk: "Deposit held successfully (nothing has been charged)",
    depositRedirect: "Redirecting…",
    depositBtn: "Hold deposit of {{amount}} €",
    submit: "Send details and signature",
    submitting: "Sending…",
    submitted: "Details and signature sent ✓",
    help: "Any questions: WhatsApp +34 667 39 67 67",
    errMissing: "Please fill in at least the first name, surname and ID of each occupant",
    errSignature: "Your signature of the property condition is missing",
    okSubmitted: "Check-in registered successfully",
    errSubmit: "The check-in could not be sent",
    errDeposit: "The deposit hold could not be started",
  },
  reviews: {
    kicker: "What our guests say",
    title: "Reviews",
    sub: "Real experiences in our Cádiz homes.",
  },
};
